import React, { useState, useEffect } from "react";
import config from "../../../config";

// components
import InputSelectGroupType from "./inputSelectGroupType";
import PageTitle from "../../../components/PageTitle/PageTitle";
import Modal from "../../modals/Modal";

import AddPartnerForm from "./addPartnerForm";
import AddGroupPartnerForm from "./addGroupPartnerForm";

export default function Tables() {
  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [groupType, setGroupType] = useState({ text: '', numberOfPersons: 0, discount: 0, valid: null, isDiscountByPercent: false });

  const [costInscription, setCostInscription] = useState(null);
  const [costTraveler, setCostTraveler] = useState(null);
  const [accessCountTraveler, setAccessCountTraveler] = useState(null);
  const [allGenders, setAllGenders] = useState([]);
  const [allMembershipType, setAllMembershipType] = useState([]);
  const [allPartnerType, setAllPartnerType] = useState([]);
  const [allGroupType, setAllGroupType] = useState([]);
  const [showModal, setShowModal] = useState(false);
  //const [isOpenModalCamera, openModalCamera, closeModalCamera] = useModal(false);
  const [allDays, setAllDays] = useState([]);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fetchGenders = async () => {
    fetch(baseUrl + "genders",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error == null) {
          setAllGenders(data);
        } else {
          setShowModal(true);
        }
      }).catch(error => null);
  }

  const fetchMembershipType = async () => {
    if (!showModal) {
      fetch(baseUrl + "membershipAndService",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            setAllMembershipType(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fetchPartnerType = async () => {
    if (!showModal) {
      fetch(baseUrl + "partnerType",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            setAllPartnerType(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fetchGroupType = async () => {
    if (!showModal) {
      fetch(baseUrl + "groupTypePartner",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            var list = [];
            list.push(
              {
                "name": "Individual",
                "numberOfPersons": 1,
                "discount": 0.0,
                "isDiscountByPercent": 0,
              },
            );
            data.map((item) => {
              list.push(item);
            });
            setAllGroupType(list);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fechCostInscription = async () => {
    if (!showModal) {
      fetch(baseUrl + "getInscriptionCost",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setCostInscription(data.cost);
          }
        })
        .catch(error => null);
    }
  }

  const fechCostTraveler = async () => {
    if (!showModal) {
      fetch(baseUrl + "getTravelerCost",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setCostTraveler(data.cost);
            setAccessCountTraveler(data.accessCount);
          }
        })
        .catch(error => null);
    }
  }

  const fetchDays = async () => {
    if (!showModal) {
      fetch(baseUrl + "days",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            setAllDays(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  useEffect(() => {
    fetchGroupType();
    fetchGenders();
    fetchMembershipType();
    fetchPartnerType();
    fechCostInscription();
    fechCostTraveler();
    fetchDays();
  }, []);

  return (
    <div>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}
      <PageTitle title="Socios" />

      <div style={{ width: '50%', marginBottom: '40px' }}>
        <InputSelectGroupType
          text={groupType}
          setValue={setGroupType}
          label={"Grupo de membrecía"}
          options={allGroupType}
          isRequired={false}
        />
      </div>

      {groupType.text != '' ? (
        <>
          {groupType.numberOfPersons > 1 ? (
            <>
              <AddGroupPartnerForm
                allGenders={allGenders}
                allMembershipType={allMembershipType}
                allPartnerType={allPartnerType}
                allDays={allDays}
                costInscription={costInscription}
                costTraveler={costTraveler}
                accessCountTraveler={accessCountTraveler}
                groupType={groupType}
              />
            </>
          ) : (
            <>
              <AddPartnerForm
                allGenders={allGenders}
                allMembershipType={allMembershipType}
                allPartnerType={allPartnerType}
                allDays={allDays}
                costInscription={costInscription}
                costTraveler={costTraveler}
                accessCountTraveler={accessCountTraveler}
              />
            </>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
